import { Input } from 'antd'
import withClassName from 'core/hocs/withClassName'
import './SigInput.less'

const SigInput = withClassName('SigInput')(Input)
SigInput.TextArea = Input.TextArea
SigInput.Search = Input.Search
SigInput.Group = withClassName('SigInputGroup')(Input.Group)
export default SigInput
